import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faEdit, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../Layout/Loader';
import PrimeTable from '../../PrimeTable/PrimeTable';
import { useTranslation } from 'react-i18next';
import mainAxios from '../../../services/mainAxios';
import moment from 'moment';
import { useAppContext } from '../../../AppContext';
import ExchangeRateHistory from './ExchangeRateHistory';
import { Dialog } from 'primereact/dialog';
import ExportCsvPrime from '../../global/ExportCsvPrime';

const Currencies = () => {
    const [currencies, setCurrencies] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState({id:null,open:false});

    const { t } = useTranslation('translations');
    const {
        user: [user],
        selectedCompany = { selectedCompany },
        company: [fullCompany],
    } = useAppContext();

    const getCurrencies = () => {
        setLoading(true);
       return mainAxios.get('/api/exchange-rates/getAll')
            .then(res => {
                console.log({rest:res})
                setCurrencies(res.data);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching currencies:', error);
                setLoading(false);
            });
    };

    useEffect(() => {
        getCurrencies();
    }, []);


const manualScheduler = () => {
    setLoading(true);
    return mainAxios.get('/api/exchange-rates')
        .then(() => {
            return getCurrencies();
        })
        .catch(error => {
            console.error('Error triggering scheduler:', error);
            setLoading(false);
        });
};


    const formatModifiedDate = (dateArray) => {
        if (!dateArray) return "";
        const [year, month, day, hour, minute, second] = dateArray;
        return moment({ year, month: month - 1, day, hour, minute, second }).format("DD/MM/YYYY HH:mm:ss");
    };

    const columns = [
        {
            header: t('customers.name') + " "+ "EN",
            field: 'monedhaEn',
            filter: true,
            style: { minWidth: "100px", maxWidth: "100px" },
            mobile: { priority: 1, isTitle: true, group: "identity" },
        },
        {
            header: t('customers.name') + " "+ "AL",
            field: 'monedhaAl',
            filter: true,
            style: { minWidth: "100px", maxWidth: "100px" },
            mobile: { priority: 1, group: "identity" },
        },
        {
            header: t('item.code'),
            field: 'code',
            filter: true,
            style: { minWidth: "100px", maxWidth: "100px" },
            mobile: { priority: 1, group: "identity" },

        },
        {
            header: t('invoice.value'),
            field: 'value',
            style: { minWidth: "100px", maxWidth: "100px" },
            filter: true,
            mobile: { priority: 1, group: "financial" },
        },

        {
            header: t("common.lastUpdate"),
            field: "modifiedDate",
            style: { minWidth: "100px", maxWidth: "100px" },
            body: (currencies) => formatModifiedDate(currencies?.modifiedDate),
            formattedExportValue: true,
            mobile: { priority: 2, group: "dates" },
        },
        {
            header: t(["home.actions"]),
            field:"actions",
            style:{ minWidth: '150px', maxWidth:"150px" },
            mobile: { priority: "action", group: "actions" },
            body: (currency) => (
              <>
                <div
                  className="table-action-link"
                  onClick={() => setOpen({currency,open:true})}
                >
                  <FontAwesomeIcon icon={faChartLine} />
                  {t("common.exRateHistory")}
                </div>
              </>
            ),
          },
    ];

    const headerButtonsRight = user?.role?.id == 1 ? (
        <div className="prime-table-toolbar__add-btn" onClick={manualScheduler} style={loading ? {opacity: 0.6, pointerEvents: 'none'} : {}}>
            <FontAwesomeIcon icon={faSyncAlt} />
            {t("status.refresh")}
        </div>
    ) : null;

    const headerIcons = (
        <ExportCsvPrime
            iconOnly
            tooltip="Export CSV"
            data={currencies}
            columns={columns}
            excludedColumns={["actions"]}
            onClick={() => Promise.resolve()}
        />
    );

    return (
        <>
            <Dialog
                header={
                    <span>
                        {t("common.exRateHistory")}: <span style={{ color: 'green' }}>{open.currency?.monedhaEn}</span>
                    </span>
                }
                visible={open.open}
                onHide={() => setOpen({currency:null,open:false})}
                style={{ width: "750px", height: "500px" }}
                breakpoints={{ "960px": "75vw", "641px": "100vw" }}
            >
                {open?.open &&
                 <ExchangeRateHistory
                    onDataSuccess={()=>{
                        setOpen({currency:null,open:false});
                    }}
                    currency={open?.currency}
                    />
                }
            </Dialog>

            {currencies ? (
                <PrimeTable
                    columns={columns}
                    loading={loading}
                    value={currencies}
                    simpleTable={true}
                    reorderableColumns={true}
                    showFilters={true}
                    filterDisplay={'row'}
                    showSelectColumns={false}
                    headerButtonsRight={headerButtonsRight}
                    headerIcons={headerIcons}
                />
            ) : (
                <Loader />
            )}
        </>
    );
};

export default Currencies;
